module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img3.8b6d7d50.png";